export const financial = (n, decimals = 2) =>
  Number.parseFloat(n)
    .toFixed(decimals)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const pathWithSearch = () => {
  return window.location.pathname + window.location.search;
};
